export const SET_ELEMENT_REF = 'ELEMENT_REF/SET_ELEMENT_REF'

export const setElementRef = ({ name, height }) => ({
  type: SET_ELEMENT_REF,
  payload: { name, height },
})
